import {ColumnCode} from 'priority-web-sdk/enums';
import {RuleOperators} from '../../RuleDialog/enum';
import {BusinessRuleAction} from '../../../constants';

export const ColumnTypeToKey = {
    0: ColumnCode.Char,
    1: ColumnCode.Str,
    2: ColumnCode.Rstr,
    3: ColumnCode.Bool,
    4: ColumnCode.Real,
    5: ColumnCode.Int,
    6: ColumnCode.Date8,
    7: ColumnCode.Date10,
    8: ColumnCode.Date14,
    9: ColumnCode.Time5,
    10: ColumnCode.Time6,
    11: ColumnCode.Day,
    12: ColumnCode.Unasigned,
    13: ColumnCode.Operator
};

export const ruleActionMap = {
    DISPLAY_WARNING: BusinessRuleAction.WarningMsg,
    DISPLAY_ERROR_MSG: BusinessRuleAction.ErrorMsg,
    SEND_EMAIL: BusinessRuleAction.EmailMsg,
    SEND_TEXT_MSG: BusinessRuleAction.TextMsg,
    OPEN_TASK: BusinessRuleAction.OpenTask,
    SEND_PUSH_NOTIFICATION: BusinessRuleAction.PushNotification,
    USER_VERIFICATION: BusinessRuleAction.UserVerification,
    WEBHOOK: BusinessRuleAction.Webhook,
    ASSIGN_TO: BusinessRuleAction.AssignTo,
    CHANGE_STATUS_TO: BusinessRuleAction.ChangeStatusTo,
    CONDITIONAL_TRANSITION: BusinessRuleAction.AllowStatusChange
};

export const contextValueMap = {
    PREVIOUS_VALUE: 401,
    NEW_VALUE: 400
};

export const conditionOperatorMap = {
    IS_EMPTY: RuleOperators.blank,
    IS_NOT_EMPTY: RuleOperators.notBlank,
    HAS_CHANGED: RuleOperators.changes,
    HAS_INCREASED: RuleOperators.increases,
    HAS_DECREASED: RuleOperators.decreases,
    IS_EQUAL_TO: RuleOperators.equal,
    IS_NOT_EQUAL_TO: RuleOperators.differsFrom,
    IS_GREATER_THAN: RuleOperators.greaterThan,
    IS_GREATER_THAN_OR_EQUAL_TO: RuleOperators.greaterOrEqual,
    IS_LESS_THAN: RuleOperators.lessThan,
    IS_LESS_THAN_OR_EQUAL_TO: RuleOperators.lessOrEqual,
    IS_BETWEEN: RuleOperators.fallsBetween
};

export const logicalOperatorMap = {
    AND: false,
    OR: true
};
